<template>
  <div>
    <div>
      <h1>Formulário: {{ checklist.formName }}</h1>
    </div>
    <checklist-fill
      :checklist="checklist"
      :token="$store.getters.token"
      @finishFilling="finishFilling"
    >
    </checklist-fill>
    <b-button @click="finishFilling">Voltar</b-button>
  </div>
</template>

<script>
import ChecklistFill from "@/mixins/checklist/fill/ChecklistFill";

export default {
  name: "FormSchedulerFill",
  components: {
    ChecklistFill: () =>
      import("@/components_rms/checklist/fill/ChecklistFill.vue"),
  },
  props: {
    FormId: String,
    ChecklistId: String,
  },
  mixins: [ChecklistFill],
  data: function () {
    return {
      checklist: {
        id: 0,
        formId: 0,
        formName: "",
        draft: false,
        values: [
          {
            fieldId: 0,
            fieldName: "",
            fieldTip: "",
            fieldType: 6,
            allowsAttachment: false,
            required: false,
            value: "",
            options: null,
          },
        ],
      },
    };
  },
  created: function () {
    this.loadData();
  },
  methods: {
    async getFormSchedulerByChecklistId(id) {
      let r = await this.$apiChecklist
        .get("/schedulers/getByChecklistId/" + id.toString())
        .then((response) => {
          let checklist = response.data.data;

          if (!checklist.id) {
            checklist.id = 0;
          }
          for (let value of checklist.values) {
            value.attachment = "";
          }
          return checklist;
        })
        .catch((error) => {
          if (error.response.status == 401) {
            this.$store.dispatch("logout").then(() => {
              this.$router.push("/login");
            });
          }
          console.log(error);
          console.log(error.response.data.errors);
          return null;
        });
      return r;
    },
    finishFilling() {
      this.$router.push({
        path: `/checklist/schedules/`,
      });
    },
    async loadData() {
      this.checklist = await this.getChecklistById(
        this.$store.getters.token,
        this.ChecklistId
      );
      console.log(this.checklist);
      // this.checklist = await this.getChecklistNew(this.FormId);

      // let formScheduler = this.getFormSchedulerById(this.ChecklistId);
      // console.log(formScheduler);
    },
  },
};
</script>
